<script context="module">
    import { fetchWithHeaders, querifiedURL, getBaseURL } from "../utils.svelte";

    export async function getOffers() {
      return await fetchWithHeaders(getBaseURL() + '/offers');
    }

    export async function getOffersOverview() {
      return await fetchWithHeaders(getBaseURL() + '/offers/overview');
    }

    export async function getOfferByID(offerID) {
      return await fetchWithHeaders(getBaseURL() + `/offers/${offerID}`);
    }

    export async function createOffer(offerFormData) {
      return await fetchWithHeaders(getBaseURL() + '/offers', {
        method: 'POST',
        body: offerFormData
      });
    }

    export async function updateOffer(offerID, offerFormData) {
      return await fetchWithHeaders(getBaseURL() + `/offers/${offerID}/update`, {
        method: 'POST',
        body: offerFormData
      });
    }

    export async function deleteOffer(offerID) {
      return await fetchWithHeaders(getBaseURL() + `/offers/${offerID}`, {
        method: 'DELETE'
      });
    }
</script>
